import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../../store/storage/storage.service';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.allow();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.allow();
  }

  private allow(): Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.storageService.hasStoredSession()) {
      return this.router.parseUrl('/auth/login');
    }
    if (this.storageService.isAuthenticated()) {
      return true;
    }
    return this.authService.refreshToken(true)
      .then(() => true)
      .catch(() => {
        this.storageService.clearAuthSession();
        return this.router.parseUrl('/auth/login');
      });
  }

}

@Injectable({
  providedIn: 'root'
})
export class SessionRedirectGuard implements CanActivate {

  constructor(
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService
  ) { }

  canActivate(): Promise<UrlTree> | UrlTree {
    if (!this.storageService.hasStoredSession()) {
      return this.router.parseUrl('/auth/login');
    }
    if (this.storageService.isAuthenticated()) {
      return this.router.parseUrl('/appointments');
    }
    return this.authService.refreshToken(true)
      .then(() => this.router.parseUrl('/appointments'))
      .catch(() => {
        this.storageService.clearAuthSession();
        return this.router.parseUrl('/auth/login');
      });
  }

}
